/**
 * Returns true when the user holds at least one of the given agent codes.
 * Codes are compared as numbers because agents may carry them as strings.
 * @param {Array<number|string>} userAgentCodes
 * @param {Array<number|string>} requiredAgentCodes
 * @returns {boolean}
 */
export const hasAnyAgentCode = (userAgentCodes = [], requiredAgentCodes = []) => {
  const userCodes = new Set(userAgentCodes.map(Number));
  return requiredAgentCodes.some((code) => userCodes.has(Number(code)));
};

/**
 * Keeps the nav items the user may see. An item's `module` requires module access
 * and its optional `agentCodes` requires the user to hold one of those agent codes.
 * @param {Array<Object>} items
 * @param {{ hasModuleAccess: Function, userAgentCodes: Array<number|string> }} access
 * @returns {Array<Object>}
 */
export const filterNavItemsByAccess = (items = [], { hasModuleAccess, userAgentCodes = [] }) =>
  items.filter(({ module, agentCodes }) =>
    (!module || hasModuleAccess(module))
    && (!agentCodes || hasAnyAgentCode(userAgentCodes, agentCodes)));
